import React, { useState } from "react";

import { ViewScreenshotThumbnail } from "../../../../../components";
import { RLCSHistoryAnalysis } from "../../../@types/rldynamicanalysis";
import useFetchExtractedScreenshots from "../../../hooks/useFetchExtractedScreenshots";
import { getLatestFinishedAnalysis } from "../utils";
import RlCloudSandoxScreenshotsModal from "./RlCloudSandoxScreenshotsModal";

export type ViewScreenshotsButtonProps = {
  hash: string;
  historyAnalysis: RLCSHistoryAnalysis[];
  className?: string;
  isNetwork?: boolean;
  activeAnalysisId?: string;
};

const ViewScreenshotsButton: React.FC<ViewScreenshotsButtonProps> = ({
  hash,
  historyAnalysis = [],
  className,
  isNetwork = false,
  activeAnalysisId: activeAnalysisIdProp
}) => {
  const [showModal, setShowModal] = useState(false);
  const activeAnalysisId =
    activeAnalysisIdProp ??
    getLatestFinishedAnalysis(historyAnalysis)?.analysis_id ??
    "";

  const { imagePaths, imageGroups } = useFetchExtractedScreenshots(
    hash,
    activeAnalysisId,
    isNetwork
  );
  const lastImage = !imageGroups.length
    ? imagePaths?.[imagePaths.length - 1]
    : imagePaths?.[imageGroups[0].length - 1];
  return (
    <>
      <ViewScreenshotThumbnail
        thumbnailTitle="View Screenshots"
        errorTitle="Check for Screenshots"
        srcPath={lastImage ?? ""}
        className={className}
        onClick={() => setShowModal(true)}
      />

      <RlCloudSandoxScreenshotsModal
        hash={hash}
        historyAnalysis={historyAnalysis}
        showModal={showModal}
        isNetwork={isNetwork}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </>
  );
};

export default ViewScreenshotsButton;
